/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import styles from '../../../../styles';
import { RadioGroup } from '../../../../components/Form';

const Wrapper = styled.div`
  padding: 2rem 2rem 0 2rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const InstanceList = styled(RadioGroup)`
  height: 2rem;
  overflow-y: auto;
  padding: .25rem 1rem;
  margin: 1rem 0 1rem 0;
  > * {
    width: 50%;
  }
`;

class SimpleInstancePage extends React.Component {

  render() {
    return (
      <Wrapper>
        <Label>
          { this.props.label || 'Choose an Instance'}
        </Label>
        <InstanceList
          name={this.props.name || 'instance'}
          value={this.props.instanceKey}
          options={this.props.instanceOptions}
          onChange={this.props.setInstanceKey}
        />
      </Wrapper>
    );
  }
}

export default SimpleInstancePage;
